import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Offline detection banner — shows when navigator.onLine is false.
 * Fixed at top of screen, --aif-z-critical above everything.
 */
export default function OfflineBanner() {
  const { t } = useTranslation();
  const [online, setOnline] = useState(typeof navigator !== 'undefined' ? navigator.onLine : true);

  useEffect(() => {
    const goOnline = () => setOnline(true);
    const goOffline = () => setOnline(false);
    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);
    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);

  if (online) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[var(--aif-z-critical)] bg-amber-600 text-white text-center py-2 px-4 text-sm font-medium shadow-lg">
      {'\u26A0\uFE0F'} {t('app.offline')}
    </div>
  );
}
